import { render, staticRenderFns } from "./IconInfoBulb.vue?vue&type=template&id=4056e88c&scoped=true"
import script from "./IconInfoBulb.vue?vue&type=script&lang=js"
export * from "./IconInfoBulb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4056e88c",
  null
  
)

export default component.exports